export enum TagTypes {
  SOLID = 'solid',
  OUTLINE = 'outline',
  TEXT = 'text',
  LINK = 'link'
}

export interface TagProps {
  text: string;
  spaceX?: string; // spacing for left and right inside tag
  spaceY?: string; // spacing for top and bottom inside tag
  tagType: TagTypes;
  icon?: string;
  link?: string;
  textColor?: string; // default is white
  fontWeight?: number;
  fontSize?: number; // default is 12
  showDot?: boolean;
  h1tag?: boolean;
  mixpanelElementName?: string;
  index?: number;
}

export enum TagLocation {
  THUMBNAIL = 'thumbnail',
  CONSUMPTION_META_DATA = 'consumption_meta_data'
}

export interface TagsProps {
  spaceX?: string;
  spaceY?: string;
  tags: TagProps[];
  tagLocation?: TagLocation;
}
